// Export utilities pro CRM
export const exportToCSV = (companies, filename = 'firmy-export') => {
  const headers = [
    'Název firmy',
    'IČO', 
    'Adresa',
    'Operátor',
    'Stav',
    'Datum další akce',
    'Poslední aktivita',
    'Datum vytvoření',
    'Kontakt - Jméno',
    'Kontakt - Telefon',
    'Kontakt - Email'
  ];

  const csvData = companies.map(company => {
    const lastActivity = (company.activities || []).slice(-1)[0];
    const mainContact = (company.contacts || [])[0] || {};
    
    return [
      company.name || '',
      company.ico || '',
      company.address || '',
      company.operator || '',
      company.status || '',
      company.nextActionDate ? new Date(company.nextActionDate).toLocaleString('cs-CZ') : '',
      lastActivity ? lastActivity.text : '',
      company.createdAt ? new Date(company.createdAt).toLocaleString('cs-CZ') : '',
      mainContact.name || '',
      mainContact.phone || '',
      mainContact.email || ''
    ];
  });

  const csvContent = [
    headers.join(','),
    ...csvData.map(row => 
      row.map(field => 
        typeof field === 'string' && field.includes(',') 
          ? `"${field.replace(/"/g, '""')}"` 
          : field
      ).join(',')
    )
  ].join('\n');

  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}-${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const exportToJSON = (companies, filename = 'firmy-backup') => {
  const jsonData = JSON.stringify(companies, null, 2);
  const blob = new Blob([jsonData], { type: 'application/json' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}-${new Date().toISOString().split('T')[0]}.json`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const generateReport = (companies) => {
  const total = companies.length;
  const completed = companies.filter(c => c.status === 'Hotovo').length;
  const active = companies.filter(c => c.status !== 'Hotovo' && c.status !== 'Nemá zájem').length;
  const noInterest = companies.filter(c => c.status === 'Nemá zájem').length;
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const overdue = companies.filter(c => {
    if (!c.nextActionDate) return false;
    const actionDate = new Date(c.nextActionDate);
    return actionDate < today;
  }).length;
  
  const todayActions = companies.filter(c => {
    if (!c.nextActionDate) return false;
    const actionDate = new Date(c.nextActionDate);
    return actionDate.toDateString() === today.toDateString();
  }).length;

  const operatorStats = {};
  companies.forEach(company => {
    const operator = company.operator || 'Nepřiřazeno';
    if (!operatorStats[operator]) {
      operatorStats[operator] = { total: 0, completed: 0 };
    }
    operatorStats[operator].total++;
    if (company.status === 'Hotovo') {
      operatorStats[operator].completed++;
    }
  });

  return {
    summary: {
      total,
      completed,
      active, 
      noInterest,
      overdue,
      todayActions,
      conversionRate: total > 0 ? ((completed / total) * 100).toFixed(1) : 0
    },
    operatorStats,
    generatedAt: new Date().toISOString()
  };
};
